import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {OdooCompany} from '@/types/payments';

const defaultOdooCompany: OdooCompany = {
  name: '',
  email: '',
  address: {
    street: '',
    streetNumber: '',
    postalCode: '',
    city: '',
    country: '',
    fullAddress: ''
  },
  use19vat: null,
  phoneNumber: null,
  website: null,
  logo: null
};

interface OdooCompanyState {
  odooCompany: OdooCompany;
}

export const initialState: OdooCompanyState = {
  odooCompany: {
    ...defaultOdooCompany
  }
};

const odooCompanySlice = createSlice({
  name: 'odooCompany',
  initialState,
  reducers: {
    setOdooCompanyData(state, action: PayloadAction<Partial<OdooCompany>>) {
      state.odooCompany = {
        ...state.odooCompany,
        ...action.payload
      };
    },
    resetOdooCompanyData(state) {
      state.odooCompany = defaultOdooCompany;
    }
  }
});

export const {setOdooCompanyData, resetOdooCompanyData} =
  odooCompanySlice.actions;
export default odooCompanySlice.reducer;
